import { createContext, useContext } from "react";

export const LeaderboardContext = createContext();

export const useLeaderboardData = () => useContext(LeaderboardContext);
